import React from 'react';

const InputField = (props) => {
  /* eslint-disable max-len */
  const className = `${props.className || 'w-form'} border border-default border-gray-600 px-2 py-3 rounded-md focus:outline-none focus:border-primary-600`;
  /* eslint-enable max-len */
  return (
    <input {...props} className={className}/>
  );
};

export default InputField;
